module.exports = __webpack_public_path__ + "static/media/team.3a25a6f7.svg";